(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  // İç sayfa sol menüsü: alt kırılımı olan ögeler tıklayınca açılır/kapanır.
  DNB.SideMenu = {
    init: function () {
      var roots = document.querySelectorAll("[data-side-nav]");
      if (!roots.length) return;

      Array.prototype.forEach.call(roots, function (root) {
        if (root.getAttribute("data-side-nav-init") === "1") return;
        root.setAttribute("data-side-nav-init", "1");

        // Render: aktif bir alt item varsa, bağlı olduğu üst item'ı açık başlat.
        var activeLinks = root.querySelectorAll(".side-nav__sub-link.is-active, .side-nav__sub .is-active");
        Array.prototype.forEach.call(activeLinks, function (active) {
          var parent = active.closest(".side-nav__item.has-children");
          if (parent) parent.classList.add("is-open");
        });

        var togglers = root.querySelectorAll("[data-side-nav-toggle]");

        Array.prototype.forEach.call(togglers, function (toggler) {
          toggler.addEventListener("click", function (e) {
            e.preventDefault();
            var item = toggler.closest(".side-nav__item");
            if (!item) return;

            var isOpen = item.classList.contains("is-open");

            // Aynı seviyedeki diğer açık ögeleri kapat (akordeon)
            var siblings = item.parentNode ? item.parentNode.children : [];
            Array.prototype.forEach.call(siblings, function (sib) {
              if (sib !== item && sib.classList && sib.classList.contains("side-nav__item")) {
                sib.classList.remove("is-open");
              }
            });

            item.classList.toggle("is-open", !isOpen);
          });
        });
      });
    }
  };
})(window, document);
